import { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import Swal from "sweetalert2";
import SelectRegisteredAddress from "../../../components/Shipment/Address/SelectRegisteredAddress";
import { getRequestByAuth } from "../../../function/helper";
import useSharedData from "../../../hooks/useSharedData";
import NewAddress from "../../../modules/components/addresses/NewAddress";
import RowUi from "../../../modules/pages/newLetter/components/Ui/RowUi";
import FormSenderAddress from "./FormSenderAddress";

const SenderAddress = ({ state: { senderAddress, setSenderAddress } }) => {
  const [modalAddressSender, setModalAddressSender] = useState(false);
  const { isAgent } = useSharedData();

  const [haghighi, sethaghighi] = useState(true);
  const [hoghooghi, sethoghooghi] = useState(false);
  const [addSenderAddress, setAddSenderAddress] = useState(false);
  const [radio, setRadio] = useState(true);
  const [radio2, setRadio2] = useState(false);
  const [senderBtn, setSenderBtn] = useState(false);

  const selectSenderAddress = item => {
    setSenderAddress({
      type: item.address.type,
      id: item.address.id,
      name: item.address.name,
      family: item.address.family,
      compony: item.address.compony,
      irCode: item.address.nationalCode,
      shenase: item.address.nationalCode,
      mobile: item.address.phone,
      tel: item.address.tel,
      postCode: item.address.postCode,
      province: item.address.province_name.faName,
      city: item.address.city_name.faName,
      city_name: item.address.city_name,
      address: item.address.address,
      chaparNumber: item.address.city_name.chaparNumber,
      desc: item.address.description,
      area: item?.address?.area?.faName,
    });

    setModalAddressSender(false);
    if (item.address.type == 1) {
      sethoghooghi(true);
      sethaghighi(false);
    }
    if (item.address.type == 0) {
      sethoghooghi(false);
      sethaghighi(true);
    }
  };

  const getMyInfo = async () => {
    if (!isAgent && !senderAddress?.id) {
      const response = await getRequestByAuth("/address/v1/default/address");

      if (response && response.status === 200) {
        setSenderAddress({
          type: response.result.type,
          id: response.result.id,
          name: response.result.name,
          family: response.result.family,
          compony: response.result.compony,
          irCode: response.result.nationalCode,
          shenase: response.result.nationalCode,
          mobile: response.result.phone,
          province: response.result.province_name.faName,
          city: response.result.city_name.faName,
          area: response.result.area?.faName,
          tel: response.result.tel,
          postCode: response.result.postCode,
          address: response.result.address,
          chaparNumber: response.result.city_name.chaparNumber,
          desc: response.result.description,
          city_name: response.result.city_name,
          province_name: response.result.province_name,
        });

        sethoghooghi(response.result.type === 1 ? true : false);
        sethaghighi(response.result.type === 0 ? true : false);
      } else if (response && response.status === 401) {
        Swal.fire({
          icon: "warning",
          title: "نیاز به ورود مجدد",
          confirmButtonText: "باشه",
        }).then(() => {
          window.location.href = "/login";
        });
      }
    }
  };

  const handleRadioChange = val => {
    if (val === "others") {
      Swal.fire({
        icon: "info",
        text: "شما در حال ثبت سفارش برای دیگران هستید کلیه مسئولیت های ارسال بار غیرمجاز و خلاف مقررات بعهده دارنده پنل کاربری می باشد",
        showConfirmButton: true,
        confirmButtonText: "می پذیرم",
        showCancelButton: true,
        cancelButtonText: "انصراف",
      }).then(result => {
        if (result.isConfirmed) {
          setSenderAddress({});
          setSenderBtn(true);
          setRadio(false);
          setRadio2(true);
        }
      });
    } else {
      setSenderBtn(false);
      setRadio(true);
      setRadio2(false);
      getMyInfo();
    }
  };

  useEffect(() => {
    getMyInfo();
  }, []);

  return (
    <RowUi>
      <Col className="sender">
        <RowUi className="justify-content-sm-start">
          <Col xs={6} sm={2}>
            <p className="title-style">فرستنده</p>
          </Col>

          {!isAgent && (
            <>
              <Col xs={12} sm={6} lg={2} xl={1} className="mt-2">
                <input
                  type="radio"
                  checked={radio}
                  onChange={e => handleRadioChange(e.target.value)}
                  value="me"
                />
                <label className="me-1">خودم</label>
              </Col>

              <Col xs={12} sm={6} lg={2} xl={1} className="mt-2">
                <input
                  type="radio"
                  checked={radio2}
                  onChange={e => handleRadioChange(e.target.value)}
                  value="others"
                />
                <label className="me-1">دیگران</label>
              </Col>
            </>
          )}

          {!isAgent && senderBtn && (
            <Col>
              <button
                type="button"
                onClick={() => {
                  setModalAddressSender(true);
                }}
                className="header-button blueShadow blueBackground"
                style={{ width: "200px" }}
              >
                انتخاب آدرس قبلی فرستنده
              </button>
            </Col>
          )}

          <Col
            xs={12}
            sm={10}
            className="d-flex flex-wrap align-items-center justify-content-sm-end column-gap-2"
          >
            {isAgent && (
              <>
                <button
                  type="button"
                  onClick={() => {
                    setModalAddressSender(true);
                  }}
                  className="header-button blueShadow blueBackground"
                  style={{ width: "200px" }}
                >
                  انتخاب آدرس قبلی فرستنده
                </button>
                <button
                  className="btn-orange-header-button"
                  onClick={() => setAddSenderAddress(true)}
                >
                  ثبت آدرس جدید
                </button>
              </>
            )}
          </Col>
        </RowUi>

        {modalAddressSender && (
          <SelectRegisteredAddress
            senderOrgetter={0}
            onClose={() => setModalAddressSender(false)}
            onNewAddressClick={() => {
              setModalAddressSender(false);
              setAddSenderAddress(true);
            }}
            onSelect={address => selectSenderAddress({ address })}
          />
        )}

        {addSenderAddress && (
          <NewAddress
            onClose={() => {
              setAddSenderAddress(false);
            }}
            senderOrgetter={0}
            setResult={item => {
              selectSenderAddress(item);
              setAddSenderAddress(false);
            }}
          />
        )}

        <hr className="titre-line" />

        <FormSenderAddress
          senderAddress={senderAddress}
          haghighi={haghighi}
          hoghooghi={hoghooghi}
        />
      </Col>
      {addSenderAddress && (
        <NewAddress
          onClose={() => {
            setAddSenderAddress(false);
          }}
          senderOrgetter={0}
          setResult={item => {
            selectSenderAddress(item);
            setAddSenderAddress(false);
          }}
        />
      )}
    </RowUi>
  );
};

export default SenderAddress;
